// extracted by mini-css-extract-plugin
export var clickable = "styles-module--clickable--9208d";
export var group = "styles-module--group--eb897";
export var links = "styles-module--links--74afa";
export var text = "styles-module--text--58a83";